import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useShareActions } from '#src/app/shared/hooks/share';

import { useShareOptions } from './options';

export function usePsfShareAvailableShareActions() {
	const options = useShareOptions();
	const {
		data: {
			initial,
			petition: { shareInitial, shareNonInitial },
		},
	} = usePsfSharePageData();
	const links = initial ? shareInitial.links : shareNonInitial.links;
	return useShareActions(links, options);
}
